import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { STORE_DETAILS_TAB_PARAM } from './features/storeDetails/utils/storeDetailsQueryParams';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const searchParams = new URLSearchParams(window.location.search);
const isRemoteVncRoute =
  window.location.pathname.startsWith('/remote-vnc/')
  || searchParams.get(STORE_DETAILS_TAB_PARAM) === 'lotto_reco_console';

root.render(
  isRemoteVncRoute ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
